import { render, staticRenderFns } from "./projectUser.vue?vue&type=template&id=5aa98c8d"
import script from "./projectUser.vue?vue&type=script&lang=js"
export * from "./projectUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports